export default "__VITE_ASSET__OVkM9TtH__"